module.exports = __webpack_public_path__ + "static/img/154.e403899.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/154.png
// module id = FaHu
// module chunks = 0